import React from 'react';
import { IssueViewSecurityLevelField } from '@atlassian/jira-issue-view-layout-security-level-field/src/ui/index.tsx';
import type { headerActions_issueViewFoundation_HeaderActionsView$data } from '@atlassian/jira-relay/src/__generated__/headerActions_issueViewFoundation_HeaderActionsView.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import { SecurityLevelIcon } from '../../header/security-level/index.tsx';

const SecurityLevelDropDownItem = ({
	securityLevelField,
}: {
	securityLevelField?: headerActions_issueViewFoundation_HeaderActionsView$data | null;
}) => {
	if (securityLevelField && fg('relay-migration-issue-header-and-parent')) {
		return <IssueViewSecurityLevelField securityLevelField={securityLevelField} />;
	}
	return (
		<SecurityLevelIcon data-testid="issue-view-foundation.issue-actions.security-level.security-level-icon" />
	);
};
export const securityLevelDropdownGroup = (
	securityLevelField?: headerActions_issueViewFoundation_HeaderActionsView$data | null,
) =>
	({
		name: '',
		key: 'security-level-dropdown-group',
		items: [
			<SecurityLevelDropDownItem securityLevelField={securityLevelField} key="security-level" />,
		],
	}) as const;
